import React from 'react';

const DashboardContent = ({children}) => {
	return <div className="admin-content-right flex-shrink-0">
		{children}
	</div>;
};

export default DashboardContent;